import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DateService from "../../../Services/Shared/Date.service";
const defaultGetDateString = (date) => DateService.getRelativeShortTime(date);
const compactGetDateString = (date) => DateService.getCompactRelativeTime(date);
const defaultRefreshTimes = [
    {
        // For under 10 seconds, update once a second
        differenceMs: 10 * 1000,
        refresh: 1000,
    },
    {
        // For under a minute, update every 10 seconds
        differenceMs: 60 * 1000,
        refresh: 10 * 1000,
    },
    {
        // For under an hour, update every minute
        differenceMs: 60 * 60 * 1000,
        refresh: 60 * 1000,
    },
    {
        // For under a day, update every half hour
        differenceMs: 24 * 60 * 60 * 1000,
        refresh: 30 * 60 * 1000,
    },
    {
        // Otherwise update every day
        differenceMs: Infinity,
        refresh: 24 * 60 * 60 * 1000,
    },
];
const compactRefreshTimes = [
    {
        // For under a minute, update every second
        differenceMs: 60 * 1000,
        refresh: 1000,
    },
    {
        // For under an hour, update every minute
        differenceMs: 60 * 60 * 1000,
        refresh: 60 * 1000,
    },
    {
        // For under a day, update every half hour
        differenceMs: 24 * 60 * 60 * 1000,
        refresh: 30 * 60 * 1000,
    },
    {
        // Otherwise update every day
        differenceMs: Infinity,
        refresh: 24 * 60 * 60 * 1000,
    },
];
const makeRefreshTimeMs = (differences) => {
    const sortedDifferences = Array.from(differences);
    sortedDifferences.sort((a, b) => a.differenceMs - b.differenceMs);
    return (date) => {
        const ms = new Date().getTime() - date.getTime();
        for (const difference of sortedDifferences) {
            if (ms < difference.differenceMs) {
                return difference.refresh;
            }
        }
        // Default refresh once a minute
        return 60 * 1000;
    };
};
const defaultRefreshTimeMs = makeRefreshTimeMs(defaultRefreshTimes);
const compactRefreshTimeMs = makeRefreshTimeMs(compactRefreshTimes);
/**
 * A component which updates the relative date string as time goes on
 */
const RelativeDate = ({ date, getDateString, refreshTimeMs, children, compact, }) => {
    const timeMounted = React.useRef(new Date());
    const safeProps = React.useMemo(() => {
        let safeDateString = defaultGetDateString;
        let safeRefreshTime = defaultRefreshTimeMs;
        if (compact) {
            safeDateString = compactGetDateString;
            safeRefreshTime = compactRefreshTimeMs;
        }
        if (getDateString) {
            // @ts-expect-error - TS2322 - Type '(arg1: Date) => string | null | undefined' is not assignable to type '(date: Date) => string'.
            safeDateString = getDateString;
        }
        if (refreshTimeMs) {
            // @ts-expect-error - TS2322 - Type 'number | ((arg1: Date) => number)' is not assignable to type '(date: Date) => number'.
            safeRefreshTime = refreshTimeMs;
        }
        return {
            date: date || timeMounted.current,
            getDateString: safeDateString,
            refreshTimeMs: safeRefreshTime,
        };
    }, [compact, date, getDateString, refreshTimeMs]);
    const [dateString, setDateString] = React.useState([
        safeProps.getDateString(safeProps.date),
    ]);
    React.useEffect(() => {
        const msDelay = typeof safeProps.refreshTimeMs === "function"
            ? safeProps.refreshTimeMs(safeProps.date)
            : safeProps.refreshTimeMs;
        const timeout = setTimeout(() => {
            setDateString([safeProps.getDateString(safeProps.date)]);
        }, msDelay);
        return () => {
            clearTimeout(timeout);
        };
    }, [safeProps, dateString]);
    return (
    // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
    _jsx("span", { title: DateService.displayWithTime(safeProps.date, true), children: children ? children(dateString[0]) : dateString[0] }));
};
export default RelativeDate;
